import { render, staticRenderFns } from "./town-select.vue?vue&type=template&id=a27569ec&scoped=true&lang=html&"
import script from "./town-select.vue?vue&type=script&lang=js&"
export * from "./town-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27569ec",
  null
  
)

export default component.exports